/**
 * Formats a number into a currency string based on the provided locale and currency
 * @param amount - The amount in cents (e.g., 12900 for $129.00)
 * @param locale - The locale to use for formatting (defaults to 'en-US')
 * @param currency - The currency code to use (defaults to 'USD')
 * @returns Formatted currency string (e.g., "$129.00")
 */
export const formatCurrency = (
  amount: number,
  locale: string = 'en-US',
  currency: string = 'USD'
): string => {
  const dollars = amount / 100;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(dollars);
}; 